import { render, staticRenderFns } from "./beneficial-ownership-table-1071-row-actions.vue?vue&type=template&id=7f80c820&"
import script from "./beneficial-ownership-table-1071-row-actions.vue?vue&type=script&lang=ts&"
export * from "./beneficial-ownership-table-1071-row-actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports